import React, { useEffect, useState } from 'react';

import { productionApi as api } from 'api/production';
import { DataTable, Notifications } from 'shared';

function ViewPricing() {
    const [rows, setRows] = useState([]);
    const [notification, setNotification] = useState({ text: null, level: null });

    const columns = [
        { accessor: 'id', Header: 'ID' },
        { accessor: 'segment', Header: 'Segment' },
        { accessor: 'taxonomyName', Header: 'Taxonomy Name' },
        { accessor: 'taxonomyLevel', Header: 'Taxonomy Level' },
        { accessor: 'parentName', Header: 'Parent Name' },
        { accessor: 'parentLevel', Header: 'Parent Level' },
        { accessor: 'purchaseType', Header: 'Purchase Type' },
        { accessor: 'targetProductMargin', Header: 'Target Product Margin', editable: true },
    ];

    const getRows = async () => {
        const response = await api.getPricing();
        if (response.status === false) {
            setNotification({ text: `No entries found ${response.msg}`, level: 'error' });
            setRows([]);
            return;
        }

        const filteredArr = response.data.rows.reduce((filtered, row) => {
            row.taxonomyLevel <= 2 && filtered.push(row);
            return filtered;
        }, []);

        setRows(filteredArr);
        // setRows(response.data.rows);
    };

    useEffect(() => {
        getRows();
    }, []);

    return (
        <div>
            <h1>Pricing</h1>
            <Notifications options={notification} />
            {}
            <div>
                <DataTable
                    columns={columns}
                    data={rows}
                    editable
                    saveEdit={async ({ field, id, row, value }) => {
                        const res = await api.updatePricing(id, field, value);
                        if (!res.status) {
                            setNotification({ text: res.msg, level: 'error' });
                            return false;
                        }

                        setNotification({ text: 'Pricing updated', level: 'success' });
                        getRows();
                        return true;
                    }}
                />
            </div>
        </div>
    );
}

export { ViewPricing };
